// extracted by mini-css-extract-plugin
export default {"loaderPanel":"loaderPanel--DVHsP"};